import { get, post } from '../../utils/http';

export const CsBulkCreatePositions = (params) => post(`/cs/bulkCreatePositions`, params);

export const CsGetBranch = ({ branchId }) => get(`/cs/branches/${branchId}`);

export const CsArchiveBranch = ({ branchId }) => post(`/cs/archiveBranch`, { branchId });

export const CsFindFloatingEmployee = (params) => post(`/cs/findFloatingEmployee`, params);

export const CsAttachFloatingEmployeeToBranch = (params) => post(`/cs/attachFloatingEmployeeToBranch`, params);
